export const menuTypes={
    MENU_SHOWDRAWER:"MENU_SHOWDRAWER",
    MENU_CLOSEDRAWER:"MENU_CLOSEDRAWER",
    MENU_ITEM_SELECTED:"MENU_ITEM_SELECTED",
    MENU_FULLSCREAN:"MENU_FULLSCREAN"
}